export default __webpack_public_path__ + "static/media/email.a254848f.svg";